import {
  ImageIcon,
  Lightbulb,
  NotepadTextDashedIcon,
  PlusIcon,
  Trash2,
  ZoomInIcon,
  ZoomOutIcon,
} from 'lucide-react';
import React from 'react';

const CenterPanel = ({
  selectedNode,
  selectedEdge,
  deleteSelectedNode,
}: {
  selectedNode: any;
  selectedEdge: any;
  deleteSelectedNode: () => void;
}) => {
  return (
    <div>
      <div className="bg-card rounded-lg shadow-sm border border-border px-2 py-2 flex items-center space-x-2">
        <button className="flex items-center space-x-2 bg-muted hover:bg-muted/80 text-foreground px-3 py-2 rounded-lg transition-colors">
          <PlusIcon className="w-4 h-4" />
          <span className="text-sm font-medium">Build</span>
        </button>

        <div className="w-px h-6 bg-border"></div>
        <button className="p-2 text-muted-foreground hover:text-foreground transition-colors">
          <Lightbulb className="w-5 h-5" />
        </button>

        <div className="w-px h-6 bg-border"></div>
        <button className="p-2 text-muted-foreground hover:text-foreground transition-colors">
          <ImageIcon className="w-5 h-5" />
        </button>

        <div className="w-px h-6 bg-border"></div>
        <button className="p-2 text-muted-foreground hover:text-foreground transition-colors">
          <ZoomOutIcon className="w-5 h-5" />
        </button>

        <span className="text-sm text-foreground font-medium">100%</span>

        <button className="p-2 text-muted-foreground hover:text-foreground transition-colors">
          <ZoomInIcon className="w-5 h-5" />
        </button>

        <div className="w-px h-6 bg-border"></div>
        <button className="p-2 text-muted-foreground hover:text-foreground transition-colors">
          <NotepadTextDashedIcon className="w-5 h-5" />
        </button>

        {selectedNode &&
          !selectedNode.data?.isDefault &&
          selectedNode.data?.type !== 'merge' && (
            <>
              <div className="w-px h-6 bg-border"></div>
              <button
                onClick={deleteSelectedNode}
                className="flex items-center space-x-2 bg-destructive-background hover:bg-destructive-background/80 text-destructive px-3 py-2 rounded-lg transition-colors"
              >
                <Trash2 className="w-4 h-4" />
                <span className="text-sm whitespace-nowrap font-medium">
                  Delete Node
                </span>
              </button>
            </>
          )}
      </div>
    </div>
  );
};

export default CenterPanel;
